var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"position":"relative","top":"-3px"}},_vm._l((Math.floor(_vm.stars)),function(n){return _c('i',{key:n,staticClass:"fas fa-star mr-1",style:({color: _vm.color}),attrs:{"title":_vm.stars + ' ' + (_vm.stars === 1 ? 'star' : 'stars')}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }